module.exports = __webpack_public_path__ + "img/small-2-mob.c21afad3.jpg";